const isString = value => typeof value === 'string';
const isNonEmptyString = value => isString(value) && !!value;
const isBoolean = value => typeof value === 'boolean';
const isNumber = value => typeof value === 'number' && !isNaN(value);
/**
 * Deteremine whether a number is negative
 */

const isNegative = num => num < 0;
const isEncrypted = maybeEncrypted => {
  if (maybeEncrypted === null || maybeEncrypted === void 0 ? void 0 : maybeEncrypted.encrypted) return true;
  return false;
};
/**
 * This is useful within complex validators and helpers to ensure the input
 * value is an object and then to do further checks.
 */

const isObject = value => !!value && typeof value === 'object' && !Array.isArray(value);
const isNonEmptyArray = arr => Array.isArray(arr) && (arr === null || arr === void 0 ? void 0 : arr.length) > 0;

export { isBoolean, isEncrypted, isNegative, isNonEmptyArray, isNonEmptyString, isNumber, isObject, isString };
